import {
  STOCK_GET_DICTIONARY_ATTRIBUTES_BEGIN,
  STOCK_GET_DICTIONARY_ATTRIBUTES_SUCCESS,
  STOCK_GET_DICTIONARY_ATTRIBUTES_FAILURE,
  STOCK_GET_DICTIONARY_ATTRIBUTES_DISMISS_ERROR
} from './constants'
import { BFFAgent } from '../../../common/BFFAgent'
export function getDictionaryAttributes(args = {}) {
  return dispatch => {
    dispatch({
      type: STOCK_GET_DICTIONARY_ATTRIBUTES_BEGIN
    })

    const promise = new Promise((resolve, reject) => {

      const doRequest = BFFAgent.Catalogs.getMassiveUploadSchema()
      doRequest.then(
        schema => {
          if (schema) {
            const attributeList = [{ label: 'Todos', value: null }]
            Object.keys(schema).forEach(key => {
              const value = { value: key, label: schema[key]?.name }
              attributeList.push(value)
            })
            dispatch({
              type: STOCK_GET_DICTIONARY_ATTRIBUTES_SUCCESS,
              data: attributeList
            })
            resolve(schema)
          } else {
            reject()
          }
        },
        err => {
          dispatch({
            type: STOCK_GET_DICTIONARY_ATTRIBUTES_FAILURE,
            data: { error: err }
          })
          reject(err)
        }
      )
    })

    return promise
  }
}

export function dismissGetDictionaryAttributesError() {
  return {
    type: STOCK_GET_DICTIONARY_ATTRIBUTES_DISMISS_ERROR
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case STOCK_GET_DICTIONARY_ATTRIBUTES_BEGIN:
      return {
        ...state,
        getDictionaryAttributesPending: true,
        getDictionaryAttributesError: null
      }

    case STOCK_GET_DICTIONARY_ATTRIBUTES_SUCCESS:
      return {
        ...state,
        dictionaryAttributes: action.data,
        getDictionaryAttributesPending: false,
        getDictionaryAttributesError: null
      }

    case STOCK_GET_DICTIONARY_ATTRIBUTES_FAILURE:
      return {
        ...state,
        getDictionaryAttributesPending: false,
        getDictionaryAttributesError: action.data.error
      }

    case STOCK_GET_DICTIONARY_ATTRIBUTES_DISMISS_ERROR:
      return {
        ...state,
        getDictionaryAttributesError: null
      }

    default:
      return state
  }
}
